module.exports = __webpack_public_path__ + "img/Gestor_Logo_.3412813b.svg";